/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019,2020. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */

import { CarbonTitleField } from './CarbonTitleField';
import { CarbonDescriptionField } from './CarbonDescriptionField';
import { CustomSchemaField } from './CustomSchemaField';

export const fields = {
    TitleField: CarbonTitleField,
    DescriptionField: CarbonDescriptionField,
    SchemaField: CustomSchemaField
};